'use client';

import { useEffect } from 'react';

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error('[Aula] Global application error', error);
    void fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        kind: 'global-error-boundary',
        name: error.name,
        message: error.message,
        digest: error.digest ?? null,
        path: typeof window !== 'undefined' ? window.location.pathname : null,
      }),
      keepalive: true,
    }).catch(() => {});
  }, [error]);

  return (
    <html lang="en">
      <body>
        <main
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#f8fafc',
            color: '#0f172a',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <section
            style={{
              width: '100%',
              maxWidth: 460,
              padding: 28,
              borderRadius: 24,
              border: '1px solid #e2e8f0',
              background: '#ffffff',
              boxShadow: '0 18px 45px rgba(15, 23, 42, 0.12)',
              textAlign: 'center',
            }}
          >
            <div
              aria-hidden="true"
              style={{
                width: 48,
                height: 48,
                margin: '0 auto',
                borderRadius: 999,
                background: '#f1f5f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              !
            </div>
            <h1 style={{ margin: '16px 0 0', fontSize: 22 }}>Something went wrong.</h1>
            <p style={{ margin: '10px 0 0', color: '#475569', lineHeight: 1.6, fontSize: 14 }}>
              Aula ran into a problem loading this page. Try again, or reload the page if the problem continues.
            </p>
            <div style={{ display: 'grid', gap: 10, marginTop: 22 }}>
              <button
                type="button"
                onClick={reset}
                style={{
                  minHeight: 44,
                  borderRadius: 12,
                  border: '1px solid #cbd5e1',
                  background: '#ffffff',
                  color: '#0f172a',
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                Try again
              </button>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{
                  minHeight: 44,
                  borderRadius: 12,
                  border: 0,
                  background: '#0f172a',
                  color: '#ffffff',
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                Reload page
              </button>
            </div>
          </section>
        </main>
      </body>
    </html>
  );
}
